import styled, { css } from 'styled-components';
import TextCropper from '@omilia/text-cropper';

import Spinner from 'components/Spinner';

import { getThemeProp } from 'theme';

export const STextCropper = styled(TextCropper)`
  & {
    * {
      color: ${getThemeProp('colors.white')};
    }
  }
`;

export const SSearchContainer = styled.div`
  align-items: center;
  background-color: ${getThemeProp('colors.waikawaGrey')};
  display: flex;
  height: ${getThemeProp('theme.header.height')};
  position: relative;
  width: 230px;

  .icon-project {
    color: ${getThemeProp('colors.moonRakerBlue')};
    margin-left: 20px;
    position: absolute;

    &:before {
      font-size: 10px;
    }
  }

  input {
    &::placeholder,
    &::-moz-placeholder,
    &::-webkit-input-placeholder,
    &:-moz-placeholder {
      color: ${getThemeProp('colors.fogBlue')} !important;
    }
  }
`;

const menuItemHoveredOrHighlighted = css`
  background-color: ${getThemeProp('colors.kashmirBlue')};
  color: ${getThemeProp('colors.white')};
`;

export const SMenuItem = styled.div<
  { isHighlighted?: boolean } & React.HTMLAttributes<HTMLDivElement>
>`
  cursor: pointer;
  display: block;
  font-size: 11px;
  height: 24px;
  line-height: 1.4;
  overflow-x: hidden;
  padding: 5px 20px 0 42px;
  text-overflow: ellipsis;
  text-transform: uppercase;

  &:hover {
    ${menuItemHoveredOrHighlighted}
  }

  mark {
    background-color: inherit;
    color: ${getThemeProp('colors.white')};
  }

  ${props => props.isHighlighted && menuItemHoveredOrHighlighted}
`;

export const SNoProjectsResults = styled(SMenuItem)`
  cursor: auto;
  height: auto;
  color: ${getThemeProp('colors.white')};

  &:hover {
    background-color: inherit;
    color: ${getThemeProp('colors.white')};
  }
`;

export const SMenu = styled.div`
  background-color: ${getThemeProp('colors.eastBayBlue')};
  border: none;
  border-radius: 0 0 3px 3px;
  box-shadow: 0 2px 5px rgba(#000000, 0.2);
  display: block;
  max-height: 280px;
  overflow: hidden;
  overflow-y: auto;
  padding: 5px 0;
  position: absolute;
  text-transform: uppercase;
  top: ${getThemeProp('header.height')};
  width: 230px;
  z-index: 999;
`;

export const SSearchInput = styled.input`
  background: inherit;
  border: none;
  box-shadow: inset 0 -1px 0 0 ${getThemeProp('colors.dullLavenderBlue')};
  color: ${getThemeProp('colors.fogBlue')};
  font-size: 12px;
  font-weight: 300;
  line-height: unset;
  outline: none;
  padding: 14px 19px 14px 42px;
  width: 100%;
`;

export const SSpinner = styled(Spinner)`
  position: absolute;
  right: 34px;
`;
